"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DefaultStrokeWidth = 5;

var CircularProgressBar = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CircularProgressBar, _Component);

  var _super = _createSuper(CircularProgressBar);

  function CircularProgressBar() {
    var _this;

    (0, _classCallCheck2["default"])(this, CircularProgressBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.root = void 0;
    _this.dispose = void 0;
    return _this;
  }

  (0, _createClass2["default"])(CircularProgressBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fillColor = _this$props.fillColor,
          outlineColor = _this$props.outlineColor,
          strokeWidth = _this$props.strokeWidth,
          className = _this$props.className;
      var _this$geometry = this.geometry,
          height = _this$geometry.height,
          width = _this$geometry.width,
          radius = _this$geometry.radius,
          diameter = _this$geometry.diameter,
          originX = _this$geometry.originX,
          originY = _this$geometry.originY,
          circumference = _this$geometry.circumference,
          dashProgress = _this$geometry.dashProgress;
      return /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 ".concat(width, " ").concat(width),
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
        cx: width / 2,
        cy: height / 2,
        r: radius,
        fill: "none",
        strokeWidth: strokeWidth,
        stroke: outlineColor
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        className: (0, _styling.css)(this.styles.path),
        d: "M".concat(originX, " ").concat(originY, "\n              a ").concat(radius, " ").concat(radius, " 0 0 1 0 ").concat(diameter, "\n              a ").concat(radius, " ").concat(radius, " 0 0 1 0 -").concat(diameter),
        fill: "none",
        stroke: fillColor,
        strokeWidth: strokeWidth,
        strokeLinecap: "round",
        strokeDasharray: "".concat(dashProgress, ", ").concat(circumference)
      })));
    }
  }, {
    key: "styles",
    get: function get() {
      var animate = this.props.animate;
      var _this$geometry2 = this.geometry,
          width = _this$geometry2.width,
          circumference = _this$geometry2.circumference;
      var keyframes = animate && {
        to: {
          "stroke-dashoffset": 0
        },
        from: {
          "stroke-dashoffset": circumference * 0.3
        }
      };
      return _aphrodite.StyleSheet.create({
        root: {
          width: width,
          height: width
        },
        path: {
          animationName: [keyframes],
          animationDuration: "900ms",
          animationTimingFunction: "ease-out"
        }
      });
    }
  }, {
    key: "progress",
    get: function get() {
      var progress = this.props.progress;
      return Math.min(1, Math.max(0, progress));
    }
  }, {
    key: "geometry",
    get: function get() {
      var width = this.props.width;
      var height = width;
      var radius = width / 2 * 0.9;
      var diameter = radius * 2;
      var originX = width / 2;
      var originY = (height - diameter) / 2;
      var circumference = 2 * Math.PI * radius;
      var dashProgress = Math.round(this.progress * circumference);
      return {
        height: height,
        width: width,
        radius: radius,
        diameter: diameter,
        originX: originX,
        originY: originY,
        circumference: circumference,
        dashProgress: dashProgress
      };
    }
  }]);
  return CircularProgressBar;
}(_react.Component), _class3.propDoc = {
  width: {
    required: true,
    type: "number",
    description: "Width of the progress bar"
  },
  progress: {
    required: true,
    type: "number",
    description: "Current (fractional) progress value. " + " Should be between 0 and 1"
  },
  fillColor: {
    required: true,
    type: "string",
    description: "Color of the progress indicator "
  },
  outlineColor: {
    required: false,
    type: "string",
    defaultValue: _providers.DefaultThemingContext.theme.pageBackground,
    description: "Outer color of the cirlce"
  },
  strokeWidth: {
    required: false,
    type: "number",
    defaultValue: "10",
    description: "Thickness of the progress indicator"
  },
  animate: {
    required: false,
    type: "boolean",
    defaultValue: "true",
    description: "Indicates that progress value should be animated"
  }
}, _class3.defaultProps = {
  outlineColor: "white",
  animate: true,
  strokeWidth: DefaultStrokeWidth
}, _class3.demoProps = {
  width: 250,
  progress: 0.6,
  fillColor: _providers.DefaultThemingContext.theme.positiveLight,
  outlineColor: _providers.DefaultThemingContext.theme.pageBackground,
  strokeWidth: 10,
  animate: true
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "progress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "progress"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "geometry", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "geometry"), _class2.prototype)), _class2)) || _class;

var _default = CircularProgressBar;
exports["default"] = _default;